<template>
  <div class="base-spinner" :class="[theme]" :style="{ width: size, height: size }" />
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: '14px'
    },
    theme: {
      type: String,
      default: 'dark'
    }
  }
}
</script>

<style lang="scss" scoped>
.base-spinner {
  border-style: solid;
  border-width: 2px;
  border-radius: 50%;
  animation: spin 0.8s linear 0s infinite normal none running;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.dark {
  border-color: rgba(0, 0, 0, 0.6) rgba(0, 0, 0, 0.6) rgba(0, 0, 0, 0.15) rgba(0, 0, 0, 0.15);
}
.light {
  border-color: rgba(255, 255, 255, 0.9) rgba(255, 255, 255, 0.9) rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.2);
}
</style>
